import { useCallback, useState } from 'react';

/**
 * The Custom Hook usetoggle simplifies the management of a Boolean state by
 * providing a current value (value), a function for switching (toggle) and a
 * setter (setValue).It is useful for functions such as switching on and off UI
 * components or managing conditions that only have two values.
 * @param {boolean | undefined} [defaultValue] - sets a default value
 * @returns {[boolean, () => void, import("react").Dispatch<import("react").SetStateAction<boolean>>]} A tuple with the following elements:
 * - {boolean} value: The current state.
 * - {() => void} toggle: A function to toggle the current state.
 * - {Dispatch<SetStateAction<boolean>>} setValue: A function to manually set the state.
 */
export default function useToggle(defaultValue) {
  const [value, setValue] = useState(!!defaultValue);

  const toggle = useCallback(() => {
    setValue((x) => !x);
  }, []);

  return [value, toggle, setValue];
}
